var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loader
        ? [_c("mds-loader", { staticClass: "loader" })]
        : [
            _vm.isPerformanceReport
              ? _c(
                  "performance-report-options",
                  _vm._g(
                    {
                      attrs: {
                        "performance-report-parameters": _vm.parametersStepInfo,
                        editedFeed: _vm.editedFeed,
                      },
                    },
                    _vm.$listeners
                  )
                )
              : _c(
                  "div",
                  [
                    _c("investment-options", {
                      attrs: {
                        "parameter-name":
                          _vm.NOTEBOOK_PARAMETER_NAMES.investment_item,
                        investments: _vm.investmentItems,
                        "source-type": _vm.sourceType,
                        editedFeed: _vm.editedFeed,
                      },
                      on: { investmentChange: _vm.investmentChange },
                    }),
                    _vm._v(" "),
                    _vm.dataSetType === "basic"
                      ? [
                          _c("dataset-options", {
                            attrs: {
                              "parameter-name":
                                _vm.NOTEBOOK_PARAMETER_NAMES.data_set,
                              investments: _vm.datasetItems,
                              "selected-investment": _vm.investment,
                              "source-type": _vm.sourceType,
                              "binding-dataset": _vm.bindingDataset,
                              "investment-value-change":
                                _vm.investmentValueChange,
                              editedFeed: _vm.editedFeed,
                              isLoadingDataset: _vm.loadingDataset,
                            },
                            on: { datasetChange: _vm.datasetChange },
                          }),
                        ]
                      : _vm.dataSetType === "holdings"
                      ? [_c("holdings-dataset-options")]
                      : _vm._e(),
                  ],
                  2
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }